import Vue from 'vue';
import {
    getReservation,
    getReservationTypeList,
    getReservationTimeList,
    updateReservation,
    deleteApi,
    check,
    success,
    getCustomerReservationTimeList,
    getCustomerReservationTypes,
    getAssignSpDropdown,
    assignReservation,
    backReservation
} from '../../../services/personnelService/reservationService';
import { getTags, getMemberTags, storeTags } from '../../../services/backendService/tagsService';

// initial state
// state 必為模組區域變數，取時需 store.state.auth.user
// 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
// 區域使用時值需加上 name
const state = {
    reservations: [],
    pagination: {
        current_page: 0,
        per_page: 5
    },
    reservationsTypeList: [],
    reservationTimeList: [],
    tags: [],
    memberTags: [],
    assignSp: []
};

// getters
const getters = {};

// actions
const actions = {
    // 取得預約列表
    async getReservationHandler({ commit }, statusInfo) {
        const data = await getReservation(statusInfo);
        commit('setReservations', data);
    },
    // 取得預約服務內容(CA)
    async getReservationTypeListHandler({ commit }) {
        const data = await getReservationTypeList();
        commit('setReservationsTypeList', data.data);
    },
    // 拿取可預約時間列表
    async getReservationTimeListHandler({ commit }, formData) {
        const data = await getReservationTimeList(formData);
        commit('setReservationTimeList', data.data);
        return data.data;
    },
    // 修改預約
    async updateReservationHandler({}, updateInfo) {
        await updateReservation(updateInfo);
    },
    // 取消確認
    async deleteHandler({}, reservationId) {
        await deleteApi(reservationId);
    },
    // 預約確認
    async checkHandler({}, reservationId) {
        await check(reservationId);
    },
    // 完成確認
    async successHandler({}, reservationId) {
        await success(reservationId);
    },
    // 取得標籤列表
    async getTagsHandler({ commit }) {
        const data = await getTags();
        commit('setTags', data.data);
    },
    // 取得客戶標籤列表
    async getMemberTagsHandler({ commit }, member_uuid) {
        const data = await getMemberTags(member_uuid);
        commit('setMemberTags', data.data);
    },
    // 儲存標籤
    async storeTagsHandler({}, store_info) {
        await storeTags(store_info);
    },
    //* ******* 未綁定顧客API ********//
    // 取得預約列表
    async getUnbindReservationTypesHandler({ commit }, statusInfo) {
        const data = await getCustomerReservationTypes(statusInfo);
        commit('setReservationsTypeList', data.data);
    },
    // 拿取可預約時間列表
    async getUnbindReservationTimeListHandler({ commit }, formData) {
        const data = await getCustomerReservationTimeList(formData);
        commit('setReservationTimeList', data.data);
    },
    // 取得可指派SP列表
    async getAssignSpDropdownHandler({ commit }, formData) {
        const data = await getAssignSpDropdown(formData);
        commit('setAssignSpDropdown', data);
    },
    // 指派預約給 SP
    async assignReservationHandler({}, formData) {
        await assignReservation(formData);
    },
    // 轉派預約回店長
    async backReservationHandler({}, reservation_id) {
        await backReservation(reservation_id);
    },
};

// mutations
const mutations = {
    setReservations(state, data) {
        Vue.set(state, 'reservations', state.reservations.concat(data.data.reservations));
        Vue.set(state, 'pagination', data.pagination);
    },
    setReservationsTypeList(state, data) {
        Vue.set(state, 'reservationsTypeList', data.options);
    },
    // 重置所有資料
    resetHandler(state) {
        Vue.set(state, 'reservations', []);
        Vue.set(state, 'pagination', {
            current_page: 0,
            per_page: 5
        });
    },
    setReservationTimeList(state, data) {
        Vue.set(state, 'reservationTimeList', data.options);
    },
    setTags(state, data) {
        Vue.set(state, 'tags', data);
    },
    setMemberTags(state, data) {
        Vue.set(state, 'memberTags', data);
    },
    setAssignSpDropdown(state, data) {
        Vue.set(state, 'assignSp', data.options);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};